import { Typography } from "@mui/material";
import { CoreChip } from "../core";
import styles from "./QuickSetupPrompt.module.css";
import { ComponentPropsWithoutRef } from "react";
import ThemeWrapper from "../theme";

export type QuickSetupPromptProps = {
	chipText?: string;
	title?: React.ReactNode;
	description?: React.ReactNode;
} & Omit<ComponentPropsWithoutRef<"div">, "children" | "title">;

export default function QuickSetupPrompt({ chipText, title, description, ...props }: QuickSetupPromptProps) {
	return (
		<ThemeWrapper scopedCssBaselineProps={{ style: { backgroundColor: "transparent" } }}>
			<div {...props} className={`${styles.quickSetupPrompt} ${props.className || ""}`}>
				{chipText && (
					<CoreChip chipColor="#D3C6FF" fontColor="#291375" className={styles.stepChip} variant="rectangular">
						{chipText}
					</CoreChip>
				)}
				{title && <Typography className={styles.title}>{title}</Typography>}
				{description && <Typography className={styles.description}>{description}</Typography>}
			</div>
		</ThemeWrapper>
	);
}
